// appBackButton.ts — App 壳内安卓返回键处理（仅 IS_APP 注册，Web 端零影响）
//
// 刻意不 import @capacitor/app：Capacitor runtime 由安卓壳原生端注入 window.Capacitor，
// custom-ui 保持零 Capacitor 依赖（@capacitor/* 装在仓库根 mobile/）。
// 行为：WebView 有历史 → 后退一级；已在首页 → 2 秒内双击退出（提示「再按一次退出」）。

import { IS_APP } from './apiBase'

interface CapacitorAppPlugin {
  addListener: (eventName: string, callback: (data?: { canGoBack?: boolean }) => void) => unknown
  exitApp?: () => void
}

/** 「再按一次退出」轻提示（无 toast 库依赖，自绘 2.5s 自动消失） */
function showBackHint() {
  const id = 'aie-back-exit-hint'
  document.getElementById(id)?.remove()
  const el = document.createElement('div')
  el.id = id
  el.textContent = '再按一次返回键退出'
  el.style.cssText =
    'position:fixed;bottom:calc(env(safe-area-inset-bottom,0px) + 48px);left:50%;transform:translateX(-50%);' +
    'padding:8px 16px;background:rgba(15,32,75,.88);color:#fff;font-size:13px;border-radius:9999px;z-index:9999;'
  document.body.appendChild(el)
  setTimeout(() => el.remove(), 2500)
}

export function setupAppBackButton(): void {
  if (!IS_APP) return
  const capacitor = (
    window as { Capacitor?: { Plugins?: { App?: CapacitorAppPlugin } } }
  ).Capacitor
  const app = capacitor?.Plugins?.App
  if (!app?.addListener) return

  let lastBackAt = 0
  app.addListener('backButton', () => {
    // react-router（createBrowserRouter）在 history.state.idx 维护栈索引，> 0 即非首页
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0
    if (idx > 0) {
      window.history.back()
      return
    }
    const now = Date.now()
    if (now - lastBackAt < 2000) {
      app.exitApp?.()
    } else {
      lastBackAt = now
      showBackHint()
    }
  })
}
